<template>
  <div class="pc-about" ref="pcAboutBox">
    <div class="pc-about-details">

        <div class="pc-about-details-head">
            <div class="pc-about-details-head-title">
                <h2>{{companyName}}</h2><button @click="applyItem(initExpkid,teachinStatus)" :class="{isOver:teachinStatus=='已结束'}">{{teachinStatus?teachinStatus:"报名"}}</button>
            </div>
            <div class="pc-about-details-head-info">
                <div>来源高校：{{schoolName}}</div>
                <div>举办地点：{{holdPosition}}</div>
                <div>宣讲时间：{{startTime}}</div>
                <div>发布时间：{{publishTime}}</div>
            </div>
            <div class="pc-about-details-head-logo">
                <div class="logo-image">
                    <template v-if="companyLogo">
                        <img :src="companyLogo">
                    </template>
                    <template v-else>
                        <svg t="1634529011787" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4506" width="80" height="80"><path d="M665.6 819.2h102.4V435.2a25.6 25.6 0 0 1 25.6-25.6h102.4a25.6 25.6 0 0 1 25.6 25.6V819.2h102.4v204.8H0v-204.8h102.4V51.2a51.2 51.2 0 0 1 51.2-51.2h460.8a51.2 51.2 0 0 1 51.2 51.2v768zM204.8 204.8v512h153.6V204.8H204.8z m256 204.8v307.2h102.4V409.6H460.8z" p-id="4507" fill="#1296db"></path></svg>
                    </template>
                </div>
                <div class="share">
                    <svg t="1634528863424" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2458" width="14" height="14"><path d="M778.602987 653.725862c-43.735084 0-82.508155 20.923542-107.114576 53.234435l-283.026028-168.531368c3.213181-12.398378 5.100158-25.314549 5.100158-38.715767 0-3.89061-0.302899-7.686053-0.573051-11.494799l283.161105-170.612773c24.713868 28.935006 61.412698 47.344285 102.452393 47.344285 74.43427 0 134.771473-60.338227 134.771473-134.76738 0-74.42506-60.338227-134.763286-134.771473-134.763286-74.424037 0-134.759193 60.334133-134.759193 134.763286 0 14.767332 2.445702 28.916587 6.837732 42.222637L369.926214 417.98579c-27.26497-43.37795-75.391061-72.290443-130.376373-72.290443-85.053118 0-154.017816 68.959581-154.017816 154.017816s68.963675 154.012699 154.017816 154.012699c45.589314 0 86.426395-19.925818 114.624621-51.3976L648.347364 754.476497c-2.829442 10.872628-4.490268 22.23235-4.490268 34.012651 0 74.43427 60.34232 134.76738 134.76738 134.76738 74.429153 0 134.763286-60.33311 134.763286-134.76738C913.388786 714.059995 853.037257 653.725862 778.602987 653.725862L778.602987 653.725862 778.602987 653.725862zM778.602987 653.725862" p-id="2459" fill="#ea9518"></path></svg>
                    分享
                    </div>
            </div>
        </div>

        <div class="pc-about-details-content">
            <div class="teachin-text" ref="companyText">
                <div class="teachin-text-title">
                    <span @click="companyText">企业简介</span>
                    <span @click="anotherTeachin">公司其他宣讲</span>
                </div>
                <div class="teachin-text-content">{{companyIntroduction}}</div>
            </div>
            <div class="teachin-another" ref="anthorTeachin">
                <div class="teachin-another-title">
                    <span @click="companyText">企业简介</span>
                    <span @click="anotherTeachin">公司其他宣讲</span>
                </div>
                <div class="teachin-another-list">
                    <ul v-for="(item,index) in anotherTeachinList" :key="index">
                        <li>{{item.ExSchName}}</li>
                        <li>{{item.ExDate}}</li>
                        <li>{{item.ExSpaName}}</li>
                        <li><button @click="applyItem(item.ExPKID,item.ExStatus)" :class="{isOver:item.ExStatus=='已结束'}">{{item.ExStatus?item.ExStatus:"报名"}}</button></li>
                        <li><span @click="anotherDetail(item)">查看详情</span></li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer />
    </div>

    <div class="pc-about-advertise">
        <div class="pc-about-advertise-guess">你也许喜欢</div>
        <div class="pc-about-advertise-company">
            <template v-for="(item,index) in advertise">
                <div :key="index" v-if="item.ADPosition=='线下宣讲信息流'">
                    <div><img :src="item.ADImg"></div>
                    <div>{{item.ADTitle.slice(1,5)}}</div>
                </div>
            </template>
        </div>
        <div class="pc-about-advertise-posters">
            <template v-for="(item,index) in advertise">
                <div :key="index" v-if="item.ADPosition=='线下宣讲焦点图'">
                    <img :src="item.ADImg">
                </div>
            </template>
        </div>
    </div>

    <Dialog :dialog_toggle.sync="dialog">
        <template v-slot:title>
            <div class="pc-home-dialog">
                <img src="../assets/images/logo.png" alt="">
                <span>快速报名</span>
            </div>
        </template>
        <ApplyForm width="400px" :select_expkid="expkid" @close="closeApply"></ApplyForm>
    </Dialog>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue"
import Dialog from "@/components/JobDialog.vue"
import ApplyForm from "@/components/ApplyForm.vue"
export default {
    name:"PCAbout",
    data(){
        return {
            time:new Date(),
            companyIntroduction:"该企业暂未填写相关信息",
            companyLogo:"",
            anotherTeachinList:[],
            companyName:"",
            schoolName:"",
            publishTime:"",
            startTime:"",
            holdPosition:"",
            initExpkid:"",
            teachinStatus:""
        }
    },
    components:{
        Footer,
        Dialog,
        ApplyForm
    },
    created(){
        this.requestDetail()
    },
    mounted(){
        this.rq.get("/Index/SetPageView?exPKID="+window.location.search.slice(8));//点击量
    },
    computed:{
        advertise(){
            return this.$store.state.advertise
        }
    },
    methods:{
        closeApply(e){
            this.dialog=e;
        },
        // 公司简介锚点滚动
        companyText(event){
            if(this.$refs.pcAboutBox.scroll){
                this.$refs.pcAboutBox.scroll({
                    top:this.$refs.companyText.offsetTop-72,
                    behavior:"smooth"
                })
            }else{
                this.$refs.pcAboutBox.scrollTop=this.$refs.companyText.offsetTop-72;
            }
        },
        // 公司其他选件会描点跳转
        anotherTeachin(){
            if(this.$refs.pcAboutBox.scroll){
                this.$refs.pcAboutBox.scroll({
                    top:this.$refs.anthorTeachin.offsetTop-72,
                    behavior:"smooth"
                })
            }else{
                this.$refs.pcAboutBox.scrollTop=this.$refs.anthorTeachin.offsetTop-72;
            }
        },
        requestDetail(){

            this.rq.post(`/Detail/GetExecutiveDetail${window.location.search}`).then(res=>{
                let {SchoolName,CMPName,CMPIntroduction,ExList,ExDate,ExAddTime,ExSpaName,CMPLogo,ExPKID,ExStatus,Ex_PjPKID}=res.Data;
                this.publishTime=ExAddTime;
                this.startTime=ExDate;
                this.schoolName=SchoolName;
                this.companyName=CMPName;
                this.holdPosition=ExSpaName;
                this.companyIntroduction=CMPIntroduction||"该企业暂未填写相关信息";
                this.anotherTeachinList=ExList;
                this.companyLogo=CMPLogo;
                this.initExpkid=ExPKID;
                this.teachinStatus=ExStatus;
                // 获取广告
                this.$store.dispatch("asyncRequestAdvertise",Ex_PjPKID)
            },err=>{
                console.log(err)
            })
        },
        anotherDetail(item){
            let {ExAddTime,ExSpaName,ExDate,ExSchName}=item;
            this.schoolName=ExSchName;
            this.publishTime=ExAddTime;
            this.startTime=ExDate;
            this.holdPosition=ExSchName;
            if(this.$refs.pcAboutBox.scroll){
                this.$refs.pcAboutBox.scroll({
                    top:0,
                    behavior:"smooth"
                })
            }else{
                this.$refs.pcAboutBox.scrollTop=0;
            }
        }
    }

}
</script>

<style scoped lang="less">
.isOver{
    background: #ccc !important;
}
.isOver{
    background: #ccc !important;
}
.pc-about{
  max-height: calc(100vh - 60px);
  display: flex;
  overflow: auto;

  &-details{
    flex: 1 1;

    &-head{
        height: 175px;
        background: #e6e7e8;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        font-size: 14px;
        position: relative;

        &-title{
            height: 50px;
            display: flex;
            align-items: center;
            padding-left: 177px;
            button{
                border: none;
                outline: none;
                width: 60px;
                height: 23px;
                background: #ff6000;
                color: #fff;
                border-radius: 5px;
                margin-left: 21px;
                margin-top: 3px;
            }
        }
        &-info{
            height: 80px;
            background: #fff;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            padding: 12px 0;
            
            &>div{
                width: 40%;
                display: flex;
                align-items: center;

            }
        }
        &-logo{
            width: 100px;
            height: 115px;
            position: absolute;
            left: 55px;
            bottom: 30px;
            display: flex;
            flex-direction: column;

            &>div:first-child{
                flex: 1 1;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #fff;
                box-shadow: 0 0 3px rgba(0,0,0,0.2);
                border-radius: 8px;
                margin-bottom: 5px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            &>div:last-child{
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
    }
    &-content{
        background: rgba(0,0,0,0.02);
        padding: 12px 15px;
        &>div{
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0 0 2px rgba(0,0,0,0.2);
        }
        &>div:nth-child(2){
            .teachin-another-list{
                &>ul{
                    display: flex;
                    height: 51px;
                    list-style: none;
                    padding: 0 12px;
                    position: relative;
                    font-size: 14px;
                    &:hover{
                        background: rgba(0,0,0,0.015);
                    }
                    button{
                        border: none;
                        outline: none;
                        background: #ff6000;
                        color: #fff;
                        width: 60px;
                        height: 23px;
                        border-radius: 3px;
                    }
                }
                &>ul>li{
                    flex: 1 1;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                &>ul>li:nth-child(1){
                    flex: 2 1;
                }
                &>ul>li:nth-child(2){
                    flex: 2 1;
                }
                &>ul>li:nth-child(3){
                    flex: 2 1;
                }
                &>ul>li:nth-child(n+4){
                    justify-content: center;
                }
                &>ul:not(:last-child)::before{
                    content: "";
                    position: absolute;
                    bottom: 0;left: 12px;right: 12px;
                    height: 1px;
                    background: #ccc;
                    transform: scaleY(0.5);
                }
                &>ul>li:last-child>span{
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 3px;
                    width: 80px;
                    height: 23px;
                    border: 1px solid #00a5ff;
                    color: #00a5ff;
                    cursor: pointer;
                }
            }
        }
    }
  }

  &-advertise{
    width: 290px;
    text-align: left;
    padding: 5px 12px;

    &-guess{
        height: 50px;
        line-height: 60px;
        border-bottom: 1px solid #ccc;
    }

    &-company{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding-top: 8px;     

        &>div{
            width: 32%;
            height: 95px;
            margin: 2px 0;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &>div:first-child{
                height: 65%;
                width: 75%;
                border-radius: 50%;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }
            }
            &>div:nth-child(2){
                height: 20%;
                width: 85%;
                font-size: 12px;
                display: inline-flex;
                justify-content: center;
                align-items: flex-end;
            }
        }
    }
    &-posters{
        padding-top: 15px;
        &>div{
            height: 100px;
            margin: 8px 0;
            background: rgba(0,0,0,0.1);
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0 0 5px rgba(0,0,0,0.25);
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
  }
}
.teachin-text{
    margin-bottom: 25px;
    &-title{
        &>span:first-child{
            margin-right:12px;
            color: #3388ff;
            border-bottom: 1px solid #3388ff;
        }
    }
    &-content{
        min-height: 250px;
        padding: 5px 12px;
        text-align: left;
    }
}

.teachin-text-title,.teachin-another-title{
    border-bottom: 1px solid #ccc;
    height: 50px;
    display: flex;
    padding-left: 12px;
    background: rgba(0,0,0,0.015);
    position: relative;
    &>span{
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        text-decoration: none;
        color: inherit;
    }
    
}

.teachin-another{
    border-radius: 5px;
    overflow: hidden;
    &-title{
        &>span:last-child{
            color: #3388ff;
            margin-left: 12px;
            border-bottom: 1px solid #3388ff;
        }
    }
}
.pc-home-dialog{
  display: flex;
  align-items: center;
  img{
    height: 30px;
    width: 75px;
    margin-right: 12px;
  }
  span{
    color: #ff8421;
  }
}
</style>